/*
 * @Author: ken yang
 * @Date: 2023-03-07 15:20:41
 * @LastEditTime: 2023-03-07 15:21:07
 * @LastEditors: ken yang
 * @Description: 修改url参数但是不是刷新页面
 * @FilePath: /uexch_h5/src/utils/globalFunc/replaceParamVal.js
 */
function removeQueryParam (url, paramToRemove) {
  const urlObj = new URL(url)
  urlObj.searchParams.delete(paramToRemove)
  return urlObj.toString()
}

const replaceParamVal = (key, value) => {
  const oUrl = window.location.href.toString()
  let nUrl = ''
  if (!value) {
    nUrl = removeQueryParam(oUrl, key)
  } else {
    const re = eval('/(' + key + '=)([^&]*)/gi')
    nUrl = oUrl.replace(re, key + '=' + value)
  }

  window.history.pushState({}, 0, nUrl)
}

export default replaceParamVal
